// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sid-request-report-shareholder-tile__container{display:block}.sid-request-report-shareholder-tile__container .ellipsis{min-width:10px}.sid-request-report-shareholder-tile__container h4{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.sid-request-report-shareholder-tile__container p{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}", ""]);
// Exports
module.exports = exports;
